// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-45[data-v-d88fe630]{width:44%}.mb-45[data-v-d88fe630]{margin-bottom:3.9%}.service-type-container[data-v-d88fe630]{width:95%}.div-50-perc[data-v-d88fe630]{width:50%;padding:0;margin:0;height:100%;float:left}button.close[data-v-d88fe630]{color:#000!important}.form-group label[data-v-d88fe630]{font-weight:700}.date-range[data-v-d88fe630]{width:100%}.error[data-v-d88fe630]{color:red}input[data-v-d88fe630]:focus:invalid{border-color:red}", ""]);
// Exports
module.exports = exports;
